import { createStore } from 'vuex'
import menu from './modules/menu.store'
import report from './modules/report.store'
import mobilization from '@/store/modules/mobilization.store'
import info from '@/store/modules/info.store'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    menu,
    report,
    mobilization,
    info
  }
})
